<template>
    <div class="chapter backgroundImage">
        <template v-if="list.length > 0">
            <div class="chapterList" v-for="item, index in list" :key="index" @click="handleReview(item, index)">
                <p>
                    <span style=" font-weight: bold;">{{ item.paperName }}</span>
                    <i class="iconfont" style="font-size: 12px;padding-left: 4px;">&#xe61b;</i>
                </p>
                <span>
                    <i class="iconfont" style="color: #fff;box-shadow: 0px 3px 7px 0px rgba(0,0,0,0.08);padding: 0;border-radius: 50%;">&#xe626;</i>
                </span>
            </div>
        </template>
        <template v-else>
            <a-empty />
        </template>
    </div>
</template>
<script>
import { getAction } from '@/api/manage'
export default {
    name: 'chapter',
    components: {},
    data() {
        return {
            list: [],

        }
    },
    created() {
        this.init()
    },
    mounted() {document.title= this.$route.query.name },
    methods: {
        init(id) {
            // paperId，userPaperId，questionType，pageNo，pageSize
            getAction('/teaching/teachingUserPaper/myAnswerPaper', { pageNo: 1, pageSize: 999 }).then(res => {
                if (res.code == 200) {
                    this.list = res.result.records
                }
            })
        },
        handleReview(record, index) {
            let path = {
                path: '/course/ExamHistoryDetail',
                query: {
                    id: record.id,
                    name:record.paperName
                },
            }
            this.$router.push(path)
        },
    }
}
</script>
<style lang='scss' scoped>
.chapter {
    width: 100%;
    padding: 20px 17px;
    max-width: 1200px;
    margin:  0 auto;
    min-height:calc(100vh - 50px);
    background-image: url('../../assets/image/ZJ_background.png');

    .chapterList {
        width: 100%;
        cursor: pointer;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(244, 244, 244, 0.863);
        border: 0px solid;
        border-image: linear-gradient(0deg, #000000, #FFFFFF) 10 10;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.08);
        color: #6E6D6D;
        font-size: 18px;
        border-radius: 5px;
        margin: 16px 0;
        padding: 0 16px;
    }
    .chapterList:hover{
        background: #F75250;
        color: #fff;
    }
}
</style>
